export const SET_ANCILLARY_EXPERIMENTS =
  "hotelAncillary/SET_ANCILLARY_EXPERIMENTS";
export type SET_ANCILLARY_EXPERIMENTS = typeof SET_ANCILLARY_EXPERIMENTS;

export const FETCH_CFAR_QUOTES = "hotelAncillary/FETCH_CFAR_QUOTES";
export type FETCH_CFAR_QUOTES = typeof FETCH_CFAR_QUOTES;

export const SET_CFAR_QUOTES = "hotelAncillary/SET_CFAR_QUOTES";
export type SET_CFAR_QUOTES = typeof SET_CFAR_QUOTES;

export const SET_SELECTED_CFAR_ID = "hotelAncillary/SET_SELECTED_CFAR_ID";
export type SET_SELECTED_CFAR_ID = typeof SET_SELECTED_CFAR_ID;

export const SET_SELECTED_HTS_CFAR_OFFER_ID =
  "hotelAncillary/SET_SELECTED_HTS_CFAR_OFFER_ID";
export type SET_SELECTED_HTS_CFAR_OFFER_ID =
  typeof SET_SELECTED_HTS_CFAR_OFFER_ID;

export const SET_HAS_SELECTED_REFUNDABLE_ROOM =
  "flightShop/SET_HAS_SELECTED_REFUNDABLE_ROOM";
export type SET_HAS_SELECTED_REFUNDABLE_ROOM =
  typeof SET_HAS_SELECTED_REFUNDABLE_ROOM;

export const SET_HAS_ADDED_CFAR_FROM_MODAL =
  "hotelAncillary/SET_HAS_ADDED_CFAR_FROM_MODAL";
export type SET_HAS_ADDED_CFAR_FROM_MODAL =
  typeof SET_HAS_ADDED_CFAR_FROM_MODAL;
